import pick from 'lodash/pick';
import { useField } from 'react-final-form';
import { InputText } from '../../components/controls/InputText';
import { fieldConfigKeys, groupPropKeys } from '../decorateControl';
import { inputControlPropsBase } from '../utils/controlProps';
import { FinalFormGroup } from './FinalFormGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export { InputTextAnyFieldGroup } from './InputTextAnyFieldGroup';
export const InputTextFieldGroup = props => {
  const {
    name,
    id,
    controlPropsExtra
  } = props;
  const fieldProps = pick(props, fieldConfigKeys);
  const groupProps = pick(props, groupPropKeys);
  const {
    input
  } = useField(name, fieldProps);
  const controlProps = {
    ...pick(props, inputControlPropsBase),
    ...controlPropsExtra,
    ...input
  };
  return /*#__PURE__*/_jsx(FinalFormGroup, {
    name: name,
    ...groupProps,
    children: /*#__PURE__*/_jsx(InputText, {
      name: name,
      id: id || name,
      ...controlProps
    })
  });
};